import Module from 'mini-module-switcher/lib/schema/Module';
import switchModule from 'owa-mail-store/lib/actions/switchModule';
import { lazyClearFeedback } from 'mini-feedback';
import { logUsage } from 'owa-analytics';

export function feedbackModuleRouterHandler() {
    switchModule(Module.Feedback);
}

export function feedbackModuleCleanupRouterHandler(): boolean {
    logUsage('hardBackButton', ['Feedback_View']);
    lazyClearFeedback.importAndExecute();
    return false;
}
